import SymptomsSelected from './SymptomsSelected.jsx';

export default SymptomsSelected;